import React from 'react'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'

const { yellow, yellow3 } = colors

type Props = {
    nbLevels: number,
    currentLevelIndex: number
}

const LevelIndicator = (props: Props) => {
    const { nbLevels, currentLevelIndex } = props
    const complete = currentLevelIndex === nbLevels

    let levels = []

    for (let i = 0; i < nbLevels; i++) {
        levels.push(
            <Level
                key={i}
                filled={i < currentLevelIndex}
                nbLevels={nbLevels}
                hasBorder={i < nbLevels - 1}
            />
        )
    }

    return (
        <SlicesProgressIndicator>
            <FillBar
                nbLevels={nbLevels}
                currentLevelIndex={currentLevelIndex}
                complete={complete}
            />
            {levels.map(element => element)}
        </SlicesProgressIndicator>
    )
}

const SlicesProgressIndicator = styled.div`
    background: white;
    position: relative;
    width: 100%;
    height: 15px;
    border: 2px solid ${yellow};
    border-radius: 20px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
`

const FillBar = styled.div`
    position: absolute;
    background: linear-gradient(to right, ${yellow}, ${yellow3});
    border: 1px solid ${yellow};
    width: ${props => `${(100 / props.nbLevels) * props.currentLevelIndex}%`};
    ${props => props.complete && 'border-radius: 20px;'};
    height: 13px;
    margin-left: -1px;
`
const Level = styled.div`
    border-color: ${props => (props.filled ? 'white' : `${yellow}`)};
    ${props =>
        props.hasBorder &&
        `border-right: 2px solid ${props.filled ? `white` : `${yellow}`};`};
    width: ${props => `${100 / props.nbLevels}%`};
    height: 100%;
    z-index: 1;
`

export { LevelIndicator }
